import React, { use, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";

import PrintWrapper from "@/components/PrintWrapper/PrintWrapper";
import { getImportStatusAuditDetails } from "@/redux/ImportBooking/actions";
import { ImportStatusAuditGroup } from "@/data/ImportStatusAuditGroup";
import { callLoader } from "@/redux/Loader/actions";
import { showToast } from "@/redux/Toast/actions";
import PrintAuditStatus from "./PrintAuditStatus";


function ImportPrintAuditStatusPgae() {

    const dispatch = useDispatch();
    const { companyId, bookingId } = useParams();
    const [auditData, setData] = useState(null);
    const [groupedData, setGroupedData] = useState();

    useEffect(() => {
        if (companyId && bookingId) {
            _getStatusAuditDetails(bookingId, companyId);
        }
    }, [companyId, bookingId]);

    const _getStatusAuditDetails = async (bookingid, companyId) => {
        try {
            dispatch(callLoader(1));
            const resultData = await dispatch(getImportStatusAuditDetails(bookingid, companyId));
            const grouped = buildGroupedData(resultData);
            console.log("Grouped Data:", grouped);
            setGroupedData(grouped);
        } catch (error) {
            console.error("Error fetching booking details:", error);
            dispatch(showToast("Failed to load booking details", "error"))
        } finally {
            dispatch(callLoader(0));
        }
    };

    const formatLabel = (key) => key.replace(/([A-Z])/g, " $1").replace(/^./, s => s.toUpperCase());

    const buildGroupedData = (data) => {
        const grouped = {};
        Object.entries(ImportStatusAuditGroup).forEach(([groupKey, group]) => {
            grouped[groupKey] = group.keys.map((key) => {
                const dateTime = data[`${key}_dt`];
                let date = "";
                let time = "";
                if (dateTime && dateTime !== "nullZ") {
                    const dt = new Date(dateTime);
                    date = dt.toISOString().split("T")[0];
                    time = dt.toTimeString().slice(0, 5);
                }
                return {
                    id: key,
                    label: formatLabel(key),
                    checked: data[key] || false,
                    date,
                    time,
                    by: data[`${key}_by`] || "",
                };
            });
        });
        return grouped;
    };

    return (
        <PrintWrapper title={`STATUS AUDIT`}>
            {
                groupedData ?
                    (
                        <PrintAuditStatus data={groupedData} groupedData={groupedData} />
                    ) : (
                        <div>
                            <p className="text-center text-gray-500 text-lg mt-3">
                                No Data Found
                            </p>
                        </div>
                    )
            }
        </PrintWrapper>
    );
}

export default ImportPrintAuditStatusPgae;
